'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var resolver = require('../resolver.cjs');
var components = require('./components.cjs');
var pages = require('./pages.cjs');

"use strict";
const Pages = resolver.resolveSelectors(pages.versionedPages);
const Components = resolver.resolveSelectors(components.versionedComponents);
const selectors = { pages: Pages, components: Components };

exports.resolveSelectors = resolver.resolveSelectors;
exports.versionedComponents = components.versionedComponents;
exports.versionedPages = pages.versionedPages;
exports.Components = Components;
exports.Pages = Pages;
exports.selectors = selectors;
//# sourceMappingURL=index.cjs.map
